
/* eslint-disable */
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class extends Vue {
  @Prop({
    type: String,
    default: 'Add'
  }) text!: string

  @Prop({
    type: Number,
    default: 100
  }) maxMbSize!: number
  @Prop() value!: File
  @Prop() error!: string

  file: File | null = this.value || null

  fileUpdate (e: any) {
    const files: FileList = e.target.files || e.dataTransfer.files

    const mbSize = Math.ceil(files[0].size / 1024) / 1024;

    if (mbSize > this.maxMbSize) {
      this.$emit('error', 'size')
      return
    }

    if (files) {
      this.file = files[0]
      this.$emit('input', files[0])
    }
  }
}
